export default __webpack_public_path__ + "static/media/ash.bfd887a5.jpg";